import { Suspense } from 'react';
import { Navigate } from 'react-router-dom';

import PageSpinner from './components/PageSpinner';

const SondaRoute = ({ component: Component, isAuthenticated, showBasicMenu, ...rest }) => {
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if (showBasicMenu) {
    return <Navigate to="/support" />;
  }

  return (
    <Suspense fallback={<PageSpinner />}>
      <Component {...rest} />
    </Suspense>
  );
};

export default SondaRoute;
